import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios'
import moment from 'moment'

moment.locale('de')
Vue.use(Vuex);
// Vue.use(Axios);
Axios.defaults.headers.common = {'Content-Encoding': 'gzip'};
export default new Vuex.Store({
  state: {
    dogs: [],
    teams: [], tempteams: [],
    reports: [],
    footermenu: [],
    headermenu: [],
    dog: {},
    events: [],
    news: [], tempnews: [],
    page: {},
    dogfilter: [],
    doginfo: {},
    sponsors: [],
    helps: [],
    bigfont: false

  },
  mutations: {
    switchfont(state) {
      state.bigfont = !state.bigfont;
    },
    addToFilter(state, id) {
      // state.dogfilter = [];
      state.dogfilter = [id];
    },
    removeFromFilter(state, id) {
      state.dogfilter.splice(state.dogfilter.indexOf(id), 1)
    },
    getDog(state, slug) {
      let d = state.dogs.filter(d => d.slug === slug)
      state.dog = d[0]
      if (state.dog) {
        state.dog.index = state.dogs.indexOf(d[0])
      }
    },
    emptyFilter(state, id) {
      state.dogfilter = []
    },
    saveDogs(state, data) {
      state.dogs = data;
    },
    saveSponsors(state, data) {
      state.sponsors = data[0];
    },
    saveHelps(state, data) {
      state.helps = data;
    },

    saveFootermenu(state, data) {
      state.footermenu = data
    },
    saveHeadermenu(state, data) {
      state.headermenu = data
    },
    saveNews(state, data) {

      state.news = state.tempnews;
    },
    addNews(state, data, page) {
      data.forEach(function (ev) {
        ev.type = 'news'
        ev.big = ev.acf.big;
        ev.datum = moment(ev.date).format('YYYYMMDD');
      })

      data.forEach(d => state.tempnews.push(d))
    },
    emptyNews(state) {
      state.tempnews = []
    },
    saveEvents(state, data) {
      data.forEach(function (ev) {
        ev.big = ev.acf.big;
        ev.type = 'event'
        ev.datum = ev.acf.datum
      })
      state.events = data;
    },

    setDogPage(state, data) {
      state.dog = data[0];
    },
    savePage(state, data) {
      state.page = data[0];
    },
    saveDogInfo(state, data) {
      state.doginfo = data[0];
    },
    saveReports(state, data) {
      data.forEach(function (team) {
        if (team.acf.teamberichte) {
          team.acf.teamberichte.forEach(function (rep, index) {
            rep.team = team.title.rendered;
            rep.teamslug = team.slug;
            rep.type = 'report';
            rep.nummer = index + 1;
            rep.teambild = team.better_featured_image.media_details.sizes.medium.source_url
            state.reports.push(rep);
          })
        }

      });
    },
    saveTeams(state) {
      state.teams = state.tempteams;
    },
    addTeams(state, data, page) {
      data.forEach(d => state.tempteams.push(d))
    },
    emptyTeams(state) {
      state.tempteams = []
    }
  },

  actions: {
    getTeams: function (store, page = 1) {
      Axios.get('/wp-json/wp/v2/teams?orderby=menu_order&order=asc&per_page=99&page=' + page)
        .then(function (response) {
          // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
          store.commit('saveReports', response.data);
          if (page === 1) store.commit('emptyTeams');
          store.commit('addTeams', response.data, page);
          console.log(response)
          response.data.length % 99 === 0
            ? store.dispatch('getTeams', page + 1)
            : store.commit('saveTeams', response.data);
          // store.commit('saveTeams', response.data);
        }).catch(function (error) {
        if (store.state.tempteams.length > 0) store.commit('saveTeams');
      })

    },
    getDogs: function (store) {
      Axios.get('/wp-json/wp/v2/dogs?orderby=menu_order&order=asc&per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveDogs', response.data);
      });
    },
    getPageBySlug: function (store, slug) {
      store.state.page = {}
      Axios.get('/wp-json/wp/v2/pages?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePage', response.data);
      });
    },
    getDogInfoBySlug: function (store, slug) {
      Axios.get('/wp-json/wp/v2/pages?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveDogInfo', response.data);
      });
    },
    getDogBySlug: function (store, slug) {
      Axios.get('/wp-json/wp/v2/dogs?slug=' + slug).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePage', response.data);
      });
    },
    getEvents: function (store) {
      Axios.get('/wp-json/wp/v2/events?per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveEvents', response.data);
      });
    },
    getSponsors: function (store) {
      Axios.get('/wp-json/wp/v2/pages?slug=sponsoren').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveSponsors', response.data);
      });
    },
    getNews: function (store, page = 1) {
      Axios.get('/wp-json/wp/v2/posts?per_page=99&page=' + page).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        if (page === 1) store.commit('emptyNews');
        store.commit('addNews', response.data, page);
        response.data.length % 99 === 0
          ? store.dispatch('getNews', page + 1)
          : store.commit('saveNews', response.data);
      })
        .catch(function (error) {
          if (store.state.tempnews.length > 0) store.commit('saveNews');
        })
    },
    getHelps: function (store) {
      Axios.get('/wp-json/wp/v2/spenden?orderby=menu_order&order=asc&per_page=99').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveHelps', response.data);

      });
    },
    // getMenus: function (store) {
    //     Axios.get('/wp-json/wp-api-menus/v2/menus/').then(function (response) {
    //         // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
    //         store.commit('saveMenus', response.data);
    //
    //     });
    // },
    getFootermenu: function (store) {
      Axios.get('/wp-json/navi/footermenu').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveFootermenu', response.data);

      });
    },
    getHeadermenu: function (store) {
      Axios.get('/wp-json/navi/headermenu').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveHeadermenu', response.data);

      });
    }

  },

})



// WEBPACK FOOTER //
// ./src/store/index.js